var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article"},[_c('div',{staticClass:"article_back",on:{"click":_vm.goNews}},[_vm._v(" 返回列表 ")]),_c('div',{staticClass:"article_title"},[_vm._v("工信部发声 促进民营经济发展壮大")]),_c('div',{staticClass:"article_time"},[_vm._v("发布于2021年2月31日 ")]),_c('div',{staticClass:"article_con"})])
}
var staticRenderFns = []

export { render, staticRenderFns }